import {
  TableCellText,
} from "@ceridianhcm/components";
import { FormatCurrency } from "../../../../common/formatting";

export const PayFilePaymentsColumnsDefinitions = () => {
  
  return [
    {
      field: "paymentType",
      label: "Payment Type",
      cellTemplate: (cellContext: any) => (
        <TableCellText>
          <div title={cellContext.rowData.paymentType}>
            {cellContext.rowData.paymentType}
          </div>
        </TableCellText>
      ),
    },
    {
      field: "count",
      label: "Count",
      cellTemplate: (cellContext: any) => (
        <TableCellText>
          <div title={cellContext.rowData.count}>
            {cellContext.rowData.count}
          </div>
        </TableCellText>
      ),
    },
    {
      field: "amount",
      label: "Amount",
      cellTemplate: (cellContext: any) => (
        <TableCellText>
          <div title={cellContext.rowData.amount}>
            {FormatCurrency(cellContext.rowData.amount)}
          </div>
        </TableCellText>
      ),
    },
  ];
};
